module.exports = __webpack_public_path__ + "d22edecd731e370fb080507048c7fa45.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-football-s.png
// module id = 2470
// module chunks = 0